import script from "./FaceMatchStep.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceMatchStep.vue?vue&type=script&setup=true&lang=js"

import "./FaceMatchStep.vue?vue&type=style&index=0&id=a27169ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a27169ee"]])

export default __exports__